/**
 * 将时间戳格式化为 UTC YYYY/MM/DD HH:mm:ss
 * 支持秒级时间戳 (10 位) 与毫秒级时间戳 (13 位)
 */
export function formatUtcTimestamp(value?: number | null): string {
  if (value == null || typeof value !== 'number' || Number.isNaN(value) || value <= 0) {
    return '-';
  }
  // 兼容秒级与毫秒级时间戳
  const ms = value < 1e11 ? value * 1000 : value;
  const date = new Date(ms);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
}
